import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmNoThanksClickedPayload {
  professionalId?: string;
  candidateId?: string;
  shiftId?: string;
  offerId?: string;
}

/**
 * Fires when the user clicks "No Thanks" on the "review additional applications" popup.
 *
 * `shiftId` / `offerId` identify the just-confirmed shift and offer that triggered
 * the popup. The dismissal is per-professional here (the popup is about a single
 * candidate), so professional_id / candidate_id both apply and `candidate_count`
 * is 1 (GOTU-4815).
 *
 * Event: dental_portal:bulk_confirm:no_thanks_clicked
 */
export function fireBulkConfirmNoThanksClicked(
  payload: IBulkConfirmNoThanksClickedPayload = {},
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:no_thanks_clicked', {
    professional_id: payload.professionalId,
    candidate_id: payload.candidateId,
    shift_id: payload.shiftId,
    offer_id: payload.offerId,
    candidate_count: 1,
  });
}
